module.exports = __webpack_public_path__ + "media/images/products/wedding/img-compensation-case1-45a85f4da3d20e15a84d82a6f5c51e9c.png";